module.exports = __webpack_public_path__ + "img/dust.ef095ddb.png";